import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'

import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar'

export function NavMain({
  items,
  ignoreActivePaths = [],
}: {
  items: {
    title: string
    url: string
    icon?: React.ReactNode
    isActive?: boolean
    items?: {
      title: string
      url: string
    }[]
  }[]
  ignoreActivePaths?: string[]
}) {
  const location = useLocation()
  const [hoveredItem, setHoveredItem] = useState<string | null>(null)

  return (
    <SidebarMenu>
      {items.map((item) => {
        const isActive =
          location.pathname.startsWith(item.url) &&
          !ignoreActivePaths.includes(location.pathname)
        const isHovered = hoveredItem === item.title

        // 确定图标颜色
        let iconColor = '#898DA4' // 默认灰色
        if (isActive) {
          iconColor = '#8752FF' // 激活状态紫色
        } else if (isHovered) {
          iconColor = '#8752FF' // hover状态紫色
        }

        return (
          <SidebarMenuItem key={item.title}>
            <SidebarMenuButton
              asChild
              className={`
                  group flex items-center gap-2 px-4 py-3 rounded-md
                  transition-colors duration-200 ease-in-out
                  ${isActive ? 'bg-[#8752FF1A]' : ''}
                  hover:bg-[#8752FF1A] 
                  hover:text-[#8752FF] 
                `}
            >
              <Link
                to={item.url}
                className="flex items-center gap-2 w-full"
                onMouseEnter={() => setHoveredItem(item.title)}
                onMouseLeave={() => setHoveredItem(null)}
              >
                {item.icon ? (
                  <span className="transition-colors duration-200">
                    {React.isValidElement(item.icon)
                      ? React.cloneElement(item.icon, {
                          color: iconColor,
                        } as any)
                      : item.icon}
                  </span>
                ) : null}
                <span
                  className={`
                      transition-colors duration-200
                      peer-hover/menu-button:text-[#8752FF]
                      ${isActive ? 'text-[#3D1E82]' : ''}
                    `}
                >
                  {item.title}
                </span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        )
      })}
    </SidebarMenu>
  )
}
